import React from 'react';
import Axios from 'axios';
import { useState } from "react";
import Recipe from './Recipe';
import Alert1 from './Alert';
// import '../App.css';    foodrecipe.css kadala work nai karat 
import { Button } from 'react-bootstrap';
import '../style/foodrecipe.css';

function Foodrecipe(props) {
    let [data,setData] = useState("") ;
    let [recipe,setRecipe] = useState([]);
    let [alert,setAlert] = useState("");

    const APP_ID = '45586df6';
    const APP_KEY = '34af0e31ba4e7d9639753822927af5b2';
    // const url = `https://api.edamam.com/api/recipes/v2/0123456789abcdef0123456789abcdef?app_id=${APP_ID}&app_key=${APP_KEY}&type=public`;
    const url = `https://api.edamam.com/search?q=${data}&app_id=${APP_ID}&app_key=${APP_KEY}`;
       
    // let  fun = async ()=>{   // normal method async n await 
    //     let res = await fetch(url);
    //     console.log("1",res.json());
    // }    
    // fun();

    const getData = async ()=> {
        if(data !== ""){
       let result = await Axios.get(url);
       setRecipe(result.data.hits);
       if(!result.data.more){
           setAlert("No Food With Such Name")
       }
       else{
           setAlert(null);
       }
       console.log(result);
        }else{
            setAlert("please fill data");
        }
       

    }
   
   const Submit = (e)=> {
    e.preventDefault();
    getData();
    setData("");
   }

   const  Change = (e)=> {
       console.log(e.target.value);
       setData(e.target.value);
   }

    return (
    <>
        <h1>FOOD SEARCHING APP</h1>    
        
       {/* <h2> {alert !== "" && <Alert alert={alert}></Alert>}   </h2> 
        <form onSubmit={Submit} className="search-form">
        <input type="text" name="" placeholder="Search The Food" onChange={Change} value={data}></input>
        <Button variant="primary">Search</Button>
        </form>
        

        <div>
        {recipe!==[] && recipe.map((rec,i)=>{
            return <Recipe rec={rec} key={i}></Recipe>
        })}
        </div>   coomented by saurabh*/}

        <h2> {alert !== "" && <Alert1 alert={alert}></Alert1>}   </h2> 
        <form className='search-form' onSubmit={Submit}>
        <input type="text" name="" placeholder="Search The Food" autoComplete='off' onChange={Change} value={data}></input>
        <Button type='submit' variant="primary">Search</Button> 
        {/* <input type='submit' value="SEARCH"></input> */}
        </form>

        <div className='Recipe'>
        { recipe !==[] && recipe.map((rec,i)=>{
            console.log("rec",rec);
            return <Recipe rec={rec} key={i}></Recipe>
        })}
        </div>

    </>
    );
}

export default Foodrecipe;